import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IPaginationClass } from '../../../../../core/services/pagination.service';

interface IPageMc1036 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}
/* @ngInject */
export default function Mc1036Controller(
    Menu: IMenuClass, 
    MenuItemAction: IMenuItemActionClass, 
    Pagination: IPaginationClass,
    ecranDetails: IEcranDetailsResourcesEntite) {
        
    const vm: IPageMc1036 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        actions: new Menu([
            new MenuItemAction(
                'LBL_BTN_RAFFRAICHIR', 
                'BOURAF', 
                () => ({}), 
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    successAction: () => {
                        vm.multiOccurrence.fetchDataList();
                    }
                }
            ),
            new MenuItemAction(
                'LBL_BTN_ACTIVER', 
                'BOUACTIVER', 
                () => ({}), 
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    successAction: () => {
                        vm.valeursEcran.flgaffdbg = 0;
                    },
                    hidden: () => vm.valeursEcran.flgaffdbg === 0
                }
            ),
            new MenuItemAction('LBL_BTN_DESACTIVER', 'BOUDESACTIVER', () => ({}), {
                iconButton: false,
                class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                successAction: () => {
                    vm.valeursEcran.flgaffdbg = 1;
                    vm.multiOccurrence.fetchDataList();
                },
                hidden: () => vm.valeursEcran.flgaffdbg === 1
            }),
            new MenuItemAction('LBL_BTN_EFFACER', 'BOUEFFACER', () => ({}), {
                iconButton: false,
                class: 'ex-button-secondary ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                successAction: () => {
                    vm.multiOccurrence.fetchDataList();
                }
            }),
            new MenuItemAction('LBL_BTN_TRUNCATE', 'BOUTRUNCATE', () => ({}), {
                iconButton: false,
                class: 'ex-button-secondary ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                successAction: () => {
                    vm.multiOccurrence.fetchDataList();
                },
                messageConfirmation: {
                    message: 'BOUTRUNCATE_CONFIRM'
                }
            })
        ]),
        fonctions: {
            rechercheCollapsable: false,
            suiviModification: false,
            pagination: true
        },
        pagination: new Pagination({
            nombreElementPage: 500,
            nbElementsPossibles: [500, 1000]
        }),
        colonnesVisibles: [{ nom: 'dbgmsg', largeur: 800 }]
    };
}
